import { FormProvider } from 'react-hook-form';
import { RiArrowLeftSLine } from 'react-icons/ri';

import ToggleActive from '@lib/core/src/components/ToggleActive';

import { WorkflowDtoStatus } from '@/api/generated';

import {
  BackButton,
  BackButtonText,
  Header,
  NarrowCardsWrapper,
  WideCardsWrapper,
  Wrapper,
  ScrollWrapper,
  CardsWrapper,
  ToggleBox,
  Form,
  ScrollMarginDiv
} from './AiWorkflowStyles';
import KnowledgeContext from './components/KnowledgeContext';
import Preview from './components/Preview';
import FormButtons from './formComponents/FormButtons';
import Notify from './formComponents/Notifications';
import Scope from './formComponents/Scope';
import Task from './formComponents/Task';
import Title from './formComponents/Title';
import Trigger from './formComponents/Trigger';
import { LocalCapabilityType } from './formSchema';
import { useAiWorkflowLogic } from './hooks/useAiWorkflowLogic';

interface AiWorkflowProps {
  onClose: () => void;
  editWorkflow: LocalCapabilityType | null;
  setEditWorkflow: (workflow: LocalCapabilityType | null) => void;
}

const AiWorkflow = ({ onClose, editWorkflow, setEditWorkflow }: AiWorkflowProps) => {
  const {
    methods,
    handleSubmit,
    setValue,
    watch,
    submitText,
    isLargeScreen,
    isCreateLoading,
    isPatchLoading,
    handleLeave,
    onSubmit
  } = useAiWorkflowLogic({ onClose, editWorkflow, setEditWorkflow });

  return (
    <Wrapper>
      <FormProvider {...methods}>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <ScrollWrapper>
            <Header>
              <BackButton onClick={handleLeave}>
                <RiArrowLeftSLine size={16} />
                <BackButtonText>Back</BackButtonText>
              </BackButton>
              {!isLargeScreen && (
                <ToggleBox>
                  <ToggleActive
                    active={watch('status') === WorkflowDtoStatus.enabled}
                    onChange={val =>
                      setValue(
                        'status',
                        val ? WorkflowDtoStatus.enabled : WorkflowDtoStatus.disabled
                      )
                    }
                  />
                </ToggleBox>
              )}
            </Header>

            <CardsWrapper>
              <WideCardsWrapper>
                <Title />
                <Trigger />
                <Scope />
                <Task />
                <Notify />
                {isLargeScreen && <ScrollMarginDiv />}
              </WideCardsWrapper>
              <NarrowCardsWrapper>
                <Preview />
                <KnowledgeContext />
              </NarrowCardsWrapper>
              <ScrollMarginDiv />
            </CardsWrapper>
          </ScrollWrapper>
          <FormButtons
            onCancel={handleLeave}
            submitText={submitText}
            isLoading={isCreateLoading || isPatchLoading}
          />
        </Form>
      </FormProvider>
    </Wrapper>
  );
};

export default AiWorkflow;
